function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSaveRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 27h-3v-7a2 2 0 00-2-2H10a2 2 0 00-2 2v7H5V5h4v6a2 2 0 002 2h10a2 2 0 002-2V5.828l4 4.001V27zm-17 0h12v-7H10v7zm7-22v4h2V5h2v6H11V5h6zm6-2H5a2 2 0 00-2 2v22a2 2 0 002 2h22a2 2 0 002-2V9l-6-6z",
    fill: props.color
  }));
}

export default SvgIconSaveRexOutline;